<template>
  <div>
    <Loading v-if="loading" />
    <ErrorServidor v-else-if="erro" />
    <template v-else>
      <TituloPagina :titulo="tituloDaPagina" />
      <v-alert
        dark
        dense
        color="warning"
        class="mt-7"
        data-cy="informacoes_cartao"
      >
        Corrija seus dados bancários para que o reembolso da compra possa ser realizado.
      </v-alert>
      <v-row
        no-gutters
        class="flex-column mb-12"
      >
        <v-col class="mb-3" data-cy="nome_favorecido">
          Nome
          <strong class="grey--text text--darken-2">
            {{ dadosCorrigidos.full_name }}
          </strong>
        </v-col>
        <v-col class="mb-3" style="word-break: break-word;" data-cy="cpf_cnpj_favorecido">
          CPF/CNPJ <strong class="grey--text text--darken-2">
            {{ dadosCorrigidos.federal_tax_number }}
          </strong>
        </v-col>
        <v-col class="mb-3" data-cy="nome_banco">
          Banco <strong class="grey--text text--darken-2">
            {{ dadosCorrigidos.bank_name }}
          </strong>
        </v-col>
        <v-col class="mb-3" data-cy="tipo_de_conta">
          Tipo de Conta<strong class="grey--text text--darken-2">
            {{ tipoConta }}
          </strong>
        </v-col>
        <v-col class="mb-3" data-cy="agencia">
          Agência <strong class="grey--text text--darken-2">
            {{ agencia }}
          </strong>
        </v-col>
        <v-col class="mb-3" data-cy="conta">
          Conta <strong class="grey--text text--darken-2">
            {{ contaCorrente }}
          </strong>
        </v-col>
        <v-col
          v-if="dadosCorrigidos.operation_type"
          class="mb-3"
          data-cy="operacao"
        >
          Operação <strong class="grey--text text--darken-2">
            {{ dadosCorrigidos.operation_type }}
          </strong>
        </v-col>
        <v-col class="mb-3" data-cy="nome_produto">
          Produto <strong class="grey--text text--darken-2">
            {{ dadosCompra.produto }}
          </strong>
        </v-col>
        <v-col class="mb-3" data-cy="valor_da_compra">
          Valor da compra<strong class="grey--text text--darken-2">
            {{ dadosCompra.valor | moeda(dadosCompra.currency_symbol) }}
          </strong>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import api from '@/api';
import { mapGetters } from 'vuex';
import TituloPagina from '@/components/TituloPagina.vue';
import ErrorServidor from '@/components/ErrorServidor.vue';
import Loading from '@/components/Loading.vue';


export default {
  name: 'PassoCorrigirDadosBancarios',

  components: {
    TituloPagina,
    ErrorServidor,
    Loading,

  },

  props: {
    urlApi: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      tituloDaPagina: 'Corrigir dados bancários',
      dadosCorrigidos: {},
      loading: true,
      erro: false,
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),

    tipoConta() {
      const dadosDaConta = this.dadosCorrigidos.account_type;
      if (dadosDaConta === '1') return 'Corrente';

      return 'Poupança';
    },

    contaCorrente() {
      const dadosDaConta = this.dadosCorrigidos;
      if (dadosDaConta.account_number_suffix) return `${dadosDaConta.account_number}-${dadosDaConta.account_number_suffix}`;

      return dadosDaConta.account_number;
    },

    agencia() {
      const dadosDaConta = this.dadosCorrigidos;
      if (dadosDaConta.bank_branch_suffix) return `${dadosDaConta.bank_branch}-${dadosDaConta.bank_branch_suffix}`;

      return dadosDaConta.bank_branch;
    },

  },

  created() {
    this.carregarDadosBancariosIncorretos();
  },

  methods: {
    carregarDadosBancariosIncorretos() {
      api.get(this.urlApi, {
        params: {
          order_id: this.dadosCompra.venda,
        },
      })
        .then((response) => {
          this.dadosCorrigidos = response.data;
          this.$emit('bloquearProximo', false);
        })
        .catch(() => {
          this.erro = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },


};
</script>
